import React, { Component } from "react";
import PropTypes from "prop-types";
import { Card, Collapse } from "antd";
import LoadingWrapper from "../../common/loading-wrapper";
import { getFigures, getPatentText } from "../../../services/api-patents";
import { Link } from "react-router";

const styles = {
  figure: {
    width: "auto",
    height: 200
  },
  figuresRow: {
    width: "100%",
    overflowX: "auto",
    whiteSpace: "nowrap"
  },
  figuresNotFound: {
    textAlign: "center"
  },
  claimsRow: {
    marginBottom: 10
  },
  claimsDiv: {
    padding: 5,
    overflowY: "auto",
    marginBottom: 15
  },
  colorExp: {
    display: "inline-block",
    width: 100,
    height: 8,
    background: "linear-gradient(to right, #9E9E9E 0%, #BDBDBD 33%, #90CAF9 67%, #42A5F5 100%)"
  },
  colorExpNarrow: {
    color: "#9E9E9E"
  },
  colorExpBroad: {
    color: "#42A5F5"
  },
  dependentClaim: {
    background: "#f7f7f7"
  },
  truncateClaims: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  }
};

const ColorExplanation = () => (
  <div>
    <span style={styles.colorExpNarrow}>{"Narrow "}</span>
    <div style={styles.colorExp} />
    <span style={styles.colorExpBroad}>{" Broad"}</span>
  </div>
);

class PatentFullLanguage extends Component {
  static propTypes = {
    data: PropTypes.object
  };

  state = {
    figuresArr: [],
    figuresLoading: false,
    figuresNotFound: false,
    claims: [],
    scores: [],
    claimsLoading: false,
    description: [],
    descriptionLoading: false,
    independentClaimsKeys: []
  };

  render() {
    return (
      <Card title="Full Language" bodyStyle={{ padding: 10 }}>
        <Collapse bordered={false} defaultActiveKey={["abstract"]} onChange={this._handleCollapseChange}>
          <Collapse.Panel header="Abstract" key="abstract">
            <p>{this.trimXMLTags(this.props.data.abstract)}</p>
          </Collapse.Panel>
          {this._renderClaims()}
          <Collapse.Panel header="Description" key="description">
            <LoadingWrapper loading={this.state.descriptionLoading}>
              {this.state.description.map((desc, i) => (
                <p key={i}>{desc}</p>
              ))}
            </LoadingWrapper>
          </Collapse.Panel>
          {this._renderFigures()}
        </Collapse>
      </Card>
    );
  }

  _renderFigures() {
    const { figuresArr, figuresNotFound, figuresLoading } = this.state;
    return (
      <Collapse.Panel header="Figures" key="figures">
        <LoadingWrapper loading={figuresLoading}>
          {figuresArr && figuresArr.length ? (
            <div style={styles.figuresRow}>
              {figuresArr.map((figure, i) => (
                <img alt={`Patent Figure ${i}`} style={styles.figure} src={`data:image/png;base64, ${figure.imgStr}`} key={i} />
              ))}
            </div>
          ) : figuresNotFound ? (
            <div style={styles.figuresNotFound}>{"No figures found for this patent"}</div>
          ) : null}
        </LoadingWrapper>
      </Collapse.Panel>
    );
  }

  _renderClaims() {
    const { claimsLoading, claims, scores } = this.state;
    const title =
      scores.length > 0 ? (
        <span>
          {"Claim Scope Analysis (Independent Claims Only)"} <ColorExplanation />
        </span>
      ) : (
        "Claims"
      );
    return (
      <Collapse.Panel header={title} key="claims">
        <LoadingWrapper loading={claimsLoading}>
          <Collapse bordered={false} activeKeys={this.state["independentClaimsKeys"]} onChange={activeKeys => this._handleClaimsChange(activeKeys, "independentClaimsKeys")}>
            {claims.map(c => {
              const claimIndex = c.index;
              let claimHeader = this.state["independentClaimsKeys"].indexOf(claimIndex.toString()) >= 0 ? "" : c.text;
              return (
                <Collapse.Panel header={<div style={styles.truncateClaims}>{claimHeader}</div>} key={c.index}>
                  <div style={styles.claimsDiv}>
                    {c.text.split("\n").map((p, i) => (
                      <p key={i}>{p}</p>
                    ))}
                    <Link
                      to={{
                        pathname: "/patents/prior-art/pqai",
                        state: { text: c.text, ucid: this.props.data.publication_number }
                      }}
                    >
                      {"Find prior art"}
                    </Link>
                  </div>
                  <Collapse
                    bordered={false}
                    activeKeys={this.state[`dependentClaims${claimIndex}Keys`]}
                    onChange={activeKeys => this._handleClaimsChange(activeKeys, `dependentClaims${claimIndex}Keys`)}
                  >
                    {c.children.map(c => {
                      let claimHeader = this.state[`dependentClaims${claimIndex}Keys`]
                        ? this.state[`dependentClaims${claimIndex}Keys`].indexOf(claimIndex + "." + c.index) >= 0
                          ? ""
                          : c.text
                        : c.text;
                      return (
                        <Collapse.Panel header={<div style={styles.truncateClaims}>{claimHeader}</div>} key={claimIndex + "." + c.index} style={styles.dependentClaim}>
                          <div style={styles.claimsDiv}>
                            {c.text.split("\n").map((p, i) => (
                              <p key={i}>{p}</p>
                            ))}
                            <Link
                              to={{
                                pathname: "/patents/prior-art/pqai",
                                state: { text: c.text, ucid: this.props.data.publication_number }
                              }}
                            >
                              {"Find prior art"}
                            </Link>
                          </div>
                        </Collapse.Panel>
                      );
                    })}
                  </Collapse>
                </Collapse.Panel>
              );
            })}
          </Collapse>
        </LoadingWrapper>
      </Collapse.Panel>
    );
  }

  _handleClaimsChange = (activeKeys, stateKey) => {
    this.setState({ [stateKey]: activeKeys });
  };

  _handleCollapseChange = activeKeys => {
    if (activeKeys.indexOf("figures") >= 0 && !this.state.figuresNotFound && this.state.figuresArr.length == 0) {
      this._getFigures();
    } else if ((activeKeys.indexOf("claims") >= 0 && this.state.claims.length == 0) || (activeKeys.indexOf("description") >= 0 && this.state.description.length == 0)) {
      this._getFullLanguage();
    }
  };

  _getFullLanguage = () => {
    this.setState({
      claimsLoading: true,
      descriptionLoading: true
    });
    getPatentText(this.props.data.publication_number, "old")
      .then(json => {
        this.setState({
          claims: json.claims,
          description: (json.description || "").split("\n"),
          claimsLoading: false,
          descriptionLoading: false
        });
      })
      .catch(() => {
        this.setState({
          claimsLoading: false,
          descriptionLoading: false
        });
      });
  };

  _getFigures = () => {
    this.setState({
      figuresLoading: true
    });
    getFigures(this.props.data.publication_number)
      .then(json => {
        if (json.figures.length > 0) {
          this.setState({
            figuresLoading: false,
            figuresNotFound: false,
            figuresArr: json.figures
          });
        } else {
          this.setState({
            figuresLoading: false,
            figuresNotFound: true,
            figuresArr: []
          });
        }
      })
      .catch(() => {
        this.setState({
          figuresLoading: false,
          figuresNotFound: true
        });
      });
  };

  trimXMLTags = val => (val ? val.trim().replace(/<\/?[^>]+(>|$)/g, "") : "");
}

export default PatentFullLanguage;
